<template>
  <header class="header container">
    <router-link :to="{path:'/'}" class="logo">
      <img :src="logoImage" class="logo-img">
      <!-- <span class="img" :style="{background:`url(${logoImage}) no-repeat center/auto 100%`}"></span> -->
      <!-- {{logo}} -->
    </router-link>
    <slot></slot>
  </header>
</template>

<script>
export default {
  name: 'Header',

  data() {
    return {
      info: {
      }
    }
  },

  computed: {
    logo() {
      return this.$store.state.title
    },

    logoImage() {
      return this.$store.state.logo
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 90px;
  padding: 20px 0;
  .logo {
    height: 50px;
    display: block;
    font-size: 30px;
    font-weight: bold;
    float: left;
    line-height: 50px;
    // .img {
    //   display: block;
    //   float: left;
    //   margin-right: 10px;
    //   min-width: 90px;
    //   max-width: 280px;
    //   height: 50px;
    //   background: #000;
    //   // vertical-align: middle;
    // }
  }
}
.logo-img {
  min-width: 90px;
  max-width: 580px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue